package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.UniverseRepository

class DeleteUniverseUseCase(
    private val universeRepository: UniverseRepository
) {
    suspend operator fun invoke(id: String): Result<Unit> =
        universeRepository.deleteUniverse(id)
}
